import { Box, Card, CardContent, Theme, Typography } from "@mui/material";
import { Stack, SystemStyleObject } from "@mui/system";
import { ReactNode } from "react";

type LabsCardProps = {
  title?: string;
  children: ReactNode;
  sx?: SystemStyleObject<Theme>;
  compactDisplay?: boolean;
  bodySpacing?: number;
};

export const LabsCard = ({
  title,
  children,
  sx = {},
  compactDisplay = false,
  bodySpacing = 2,
}: LabsCardProps) => (
  <Card
    sx={(theme) => ({
      borderRadius: "16px",
      boxShadow: "none",
      border: `1px solid ${theme.palette.elevation.outlined}`,
      width: "100%",
      height: "100%",
      ...sx,
    })}
  >
    <CardContent
      sx={{
        margin: compactDisplay ? 0 : 2,
        padding: compactDisplay ? 1 : 2,
      }}
    >
      {title && (
        <Box sx={{ mb: compactDisplay ? 1 : 2 }}>
          <Typography variant={"h6"} color={"primary.dark"}>
            {title}
          </Typography>
        </Box>
      )}
      <Stack direction={"column"} spacing={bodySpacing}>
        {children}
      </Stack>
    </CardContent>
  </Card>
);
